module.exports = __webpack_public_path__ + "img/communication.52f0d2ff.jpg";